import React from 'react';
import { useNavigate } from 'react-router';
import Button from '../../../design-system/Button';

const Office = () => {
  const navigate = useNavigate();
  return (
    <div className="w-full bg-primary flex flex-col justify-center items-center text-light">
      <p className="py-12 text-2xl md:text-3xl lg:text-4xl font-bold">
        Cabinet
      </p>
      <div>
        <div className="flex gap-6 justify-center items-center flex-col md:flex-row md:gap-14 ">
          <img
            className="flex w-60"
            src="static/resources/Cabinet3.jpg"
            alt="Sala de asteptare"
          />
          <img
            className="flex w-60"
            src="static/resources/Cabinet2.jpg"
            alt="Sala de asteptare"
          />
        </div>
        <div className="w-full mt-4 text-sm md:text-base lg:text-lg box-border px-8 py-8 sm:py-16">
          <p className="leading-6">
            Poziționat în zonă centrală, ușor accesibilă, oferă liniște,
            curățenie și intimitate
          </p>
          <p className="leading-6">
            Posibilitatea de a lucra atât in interior cât și in aer liber.
          </p>
          <p className="leading-6">
            Activitate de lucru individuală cu fiecare copil.
          </p>
        </div>
        <div className="w-full py-12 flex justify-center">
          <Button
            variant="solid"
            color="secondary"
            className="min-w-[215px]"
            onClick={() => {
              navigate('/cabinet');
              window.scroll(0, 0);
            }}
          >
            Detalii
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Office;
